<template>
  <div id="modalSystemDiagramSelection" class="modal modal-overlay" @click.self="$emit('close')">
    <div class="system-diagram-modal">
      <div class="container">
        <div class="modal-header">
          <h2>系統図の背景ファイルを選択してください</h2>
          <button class="close-button" @click="$emit('close')">
            <div class="close-button__line close-button__line--first" @click="$emit('close')"></div>
            <div class="close-button__line close-button__line--second" @click="$emit('close')"></div>
          </button>
        </div>
        <div class="form">
          <div class="select-box">
            <select class="form-select"
              v-model="fileName">
              <option 
                v-for="(option, index) in fileS3List" 
                v-bind:value="option"
                v-bind:key="index" >{{ option }}</option>
            </select>
          </div>
          <div class="submit_area">
            <input type="submit" class="submit" value="選択" @click="onSelect" />
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "system-diagram-selection-file-s3-dialog",
  data: function() {
    return {
      fileName: '',
      fileS3List: [],
    }
  },
  mounted: function () {
    console.log("system-diagram-selection-file-s3-dialog:mounted");
    this.getData();
  },
  methods: {
    onSelect: function() {
      this.$emit('onSelectFileS3', this.fileName);
    },
    getData: function() {
      this.$axios
      .get(`/srv/api/system_diagram_setting/all_background`, {
        withCredentials: true
      })
      .then(response => {
        console.log("[GET] [all_background on S3]: OK");
        if (typeof response.data == "object") {
          this.fileS3List = response.data.background;
        } else {
          // stringのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch(error => {
        console.log("[GET] [all_background on S3]: error");
        console.log(error);
      });
    }
  }
};
</script>
